import VerifyCheck from '@/views/Check/VerifyCheck.vue'

const routes = {
  path: '/verify',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/verify',
      name: 'Verificar ponto por token',
      component: VerifyCheck,
      meta: {
        pageTitle: 'Verificar Ponto',
        breadcrumb: [
          {
            text: 'Verificar Ponto',
            active: true,
          },
        ],
      },
    },
  ],
}

export default routes
